import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function PickTicketRefreshConfirmationModalTemplate({ pickTicketRefreshConfirmationModalStore , t}) {
    const {
        isInProgres,
        hasBackOrder,
        refreshPickTicket,
        modalParams,
        isLoading
    } = pickTicketRefreshConfirmationModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Are you sure you want to refresh the Pick Ticket?</h3>
            </div>
            <div className="modal__body">
                <p>Purchasing has already {isInProgres ? "started working on" : "completed"} this order. Refreshing the pick ticket should only be done if you are sure that they have received the necessary updates.</p>
                {hasBackOrder && <p className='u-mar--top--sml'>Additionally, all backorder information of the Pick Ticket items will be deleted after refresh.</p>}
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    disabled={isLoading}
                    onClick={() => modalParams.close()}
                />
                 <BaasicButton
                    className='btn btn--med btn--primary'
                    label={t('EDIT_FORM_LAYOUT.REFRESH')}
                    disabled={isLoading}
                    onClick={async () => await refreshPickTicket()}
                    focused={true}
                    rotate icon={
                        isLoading
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}
 
PickTicketRefreshConfirmationModalTemplate.propTypes = {
    pickTicketRefreshConfirmationModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PickTicketRefreshConfirmationModalTemplate);
